<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-outer-borders`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41.778 4H6.222A2.222 2.222 0 004 6.222v35.556C4 43.005 4.995 44 6.222 44h35.556A2.222 2.222 0 0044 41.778V6.222A2.222 2.222 0 0041.778 4zM8 40V8h32v32H8z"/><rect x="22" y="10" width="4" height="4" rx="1"/><rect x="22" y="16" width="4" height="4" rx="1"/><rect x="22" y="28" width="4" height="4" rx="1"/><rect x="22" y="34" width="4" height="4" rx="1"/><rect x="22" y="22" width="4" height="4" rx="1"/><rect x="16" y="22" width="4" height="4" rx="1"/><rect x="10" y="22" width="4" height="4" rx="1"/><rect x="28" y="22" width="4" height="4" rx="1"/><rect x="34" y="22" width="4" height="4" rx="1"/></svg>
</template>
<script>

export default {
  name: 'IconOuterBorders',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
